import React from 'react'
import { translate } from 'react-i18next'
import { Routes } from '../../../utils/constants'
import SimpleLink from '../../SimpleLink'
import ServicesCard from '../../ServicesCard'

const AdditionalServices = ({ additionalServices, t, lng }) => {
  if (!additionalServices) return null
  return (
    <>
      <h4 className="subtitle-1">{t('services.additional')}</h4>
      <div className="additional-services">
        {additionalServices.map((card, index) => (
          <ServicesCard
            key={index}
            value={card.value}
            label={card.value}
            serviceTab={card.serviceTab}
          />
        ))}
      </div>
      <SimpleLink
        route={lng === 'en' ? Routes.SERVICES : `/${lng}${Routes.SERVICES}`}
        text={t('navigations.services')}
      />
    </>
  )
}

export default translate('translations')(AdditionalServices)
